import React from 'react';
import PropTypes from 'prop-types';
import CheckoutButton from '../containers/withNewCheckoutButton';
import TrackClick from '../../hoc/Analytics/TrackClick';
import { nullFunc } from '../../utils/helpers';

const ReserveAndPayButton = ({
  handleReserveAndPay,
  currency,
  totalAmount,
  email,
  paymentEnabled,
  isLadyClipperShop,
  title,
  showPromo,
  onBeforeClose,
  onBeforeOpen,
}) => (
  <TrackClick method="reserveAndPay">
    <CheckoutButton
      className="c-btn c-btn--primary u-1/1 u-mb-"
      onSuccess={handleReserveAndPay}
      currency={currency}
      amount={totalAmount}
      email={email}
      disabled={!paymentEnabled}
      showPromo={showPromo}
      onBeforeClose={onBeforeClose}
      onBeforeOpen={onBeforeOpen}
    >
      <span>
        {isLadyClipperShop ? 'Reserve now' : title}
      </span>
    </CheckoutButton>
  </TrackClick>
);

ReserveAndPayButton.propTypes = {
  handleReserveAndPay: PropTypes.func,
  currency: PropTypes.string.isRequired,
  totalAmount: PropTypes.number,
  email: PropTypes.string,
  paymentEnabled: PropTypes.bool,
  isLadyClipperShop: PropTypes.bool.isRequired,
  title: PropTypes.string,
  showPromo: PropTypes.bool,
  onBeforeOpen: PropTypes.func,
  onBeforeClose: PropTypes.func,
};

ReserveAndPayButton.defaultProps = {
  handleReserveAndPay: null,
  totalAmount: 0,
  email: '',
  paymentEnabled: false,
  isLadyClipperShop: false,
  title: 'Reserve & Pay',
  showPromo: false,
  onBeforeOpen: nullFunc,
  onBeforeClose: nullFunc,
};

export default ReserveAndPayButton;



// WEBPACK FOOTER //
// ./src/app/reservation/components/ReserveAndPayButton.jsx